export default __webpack_public_path__ + "static/media/trevor-j-alt-smiling.64a10f90.png";